// extracted by mini-css-extract-plugin
export default {"categorySelection":"CategorySelection_categorySelection__K9uGP","label":"CategorySelection_label__-tkB5","dropdownWrapper":"CategorySelection_dropdownWrapper__u2yqF"};